"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMedicalHistory = createMedicalHistory;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const heartFailureEtiology_1 = require("../../../forms/htx/medical-history/heartFailureEtiology");
const messages = {
    medicalHistory: {
        id: "dashboard.medical_history",
        defaultMessage: "Anamnézis"
    },
    heartFailureEtiology: {
        id: "dashboard.heart_failure_etiology",
        defaultMessage: "Szívelégtelenség etiológiája"
    },
    summaryReport: {
        id: "dashboard.summary_report",
        defaultMessage: "Anamnézis"
    },
    thoracotomiesSummary: {
        id: "dashboard.thoracotomies_summary",
        defaultMessage: "Thoracotomiák leírása"
    }
};
function createMedicalHistory(intl, options) {
    const heartFailureEtiology = createHeartFailureEtiology(intl, options);
    const summaryReport = createSummaryReport(intl, options);
    const throacotomiesSummary = createThoracotomiesSummary(intl, options);
    const content = (0, shared_1.createSectionContent)([
        heartFailureEtiology,
        summaryReport,
        throacotomiesSummary
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.medicalHistory, content });
}
function createHeartFailureEtiology(intl, { events }) {
    return (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        label: messages.heartFailureEtiology,
        query: queries_1.queries.heartFailureEtiology,
        messages: heartFailureEtiology_1.valueMessages
    });
}
function createSummaryReport(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.summaryReport,
        query: queries_1.queries.summaryReport
    });
}
function createThoracotomiesSummary(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.thoracotomiesSummary,
        query: queries_1.queries.thoracotomiesSummary
    });
}
